import { render, staticRenderFns } from "./addbingo.vue?vue&type=template&id=35b34bdb&scoped=true&"
import script from "./addbingo.vue?vue&type=script&lang=js&"
export * from "./addbingo.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addbingo.vue?vue&type=style&index=1&id=35b34bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b34bdb",
  null
  
)

export default component.exports